export default "__VITE_ASSET__BEMflQqu__"